const root = "/propertyManagement/creditCheck";

const creditCheckApi = {
  creditCheckList: `${root}/list`,
  creditCheckSummary: `${root}/summary`,
  creditCheckDetail: `${root}/detail`,
  creditCheckFeePolicy: `${root}/feePolicy`,
  creditCheckFormOptions: `${root}/formOptions`,
  creditCheckUnitQuote: `${root}/unitQuote`,
  creditCheckChangeUnit: `${root}/changeUnit`,
  creditCheckPreflight: `${root}/preflight`,
  creditCheckHistory: `${root}/history`,
  creditCheckCreate: `${root}/create`,
  creditCheckDecision: `${root}/decision`,
  creditCheckAdjustReceived: `${root}/adjustReceived`,
  creditCheckSkipPayment: `${root}/skipPayment`,
  creditCheckUpload: `${root}/upload`,
  creditCheckFile: `${root}/file`,
  creditCheckReport: `${root}/report`,
  creditCheckDeactivateFile: `${root}/deactivateFile`,
  creditCheckMoveInPreview: `${root}/moveInPreview`,
  creditCheckMoveIn: `${root}/moveIn`,
  creditCheckTransferTenant: `${root}/transferTenant`,
};

export default creditCheckApi;
